import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPostCounts } from "../../../redux/posts/action";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import PackagedService from "./ALLOTSProductsTabs/PackagedService";
import ProductsforSell from "./ALLOTSProductsTabs/ProductsforSell";
import RentalProducts from "./ALLOTSProductsTabs/RentalProducts";
import AuctionItems from "./ALLOTSProductsTabs/AuctionItems";
import MergersAcquisitions from "./ALLOTSProductsTabs/MergersAcquisitions";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import TranslatedText from "../../Common/TranslatedText";

export default function ALLTabsMyOTSProducts() {
  const { urlstate, setOTSroute, resetAllFields } = useRouteBaseStateContext();

  const [activeTab, setActiveTab] = useState("Packageservice");
  const dispatch = useDispatch();
  const path = "Assets/scss/myorders.module.scss";

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const postcounts = useSelector(({ posts: { postcounts } }) => postcounts);

  useEffect(() => {
    dispatch(getPostCounts(6));
  }, [dispatch]);

  useEffect(() => {
    if (urlstate?.myots) {
      setActiveTab(urlstate?.myots || "Packageservice");
    } else {
      setActiveTab("Packageservice");
    }
  }, [urlstate, urlstate?.myots]);

  const handleTabClick = (tab) => {
    resetAllFields();
    setActiveTab(tab);
    setOTSroute(tab);
  };

  return (
    <>
      <div className="order-section manage-project">
        <div className="tab-sec">
          <div className="order-first">
            <h2>All Services</h2>
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("Packageservice")}
                  className={`nav-link ${activeTab == "Packageservice" ? "active" : ""
                    }`}
                >
                  One Time Services (OTS) ({postcounts?.ots?.bxp || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("ProductforSell")}
                  className={`nav-link ${activeTab == "ProductforSell" ? "active" : ""
                    }`}
                >
                  Buy & Sell with Market (BSM) ({postcounts?.ots?.sale || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("RentalProducts")}
                  className={`nav-link ${activeTab == "RentalProducts" ? "active" : ""
                    }`}
                >
                  Turn Assets to Income (TAI) ({postcounts?.ots?.rental || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("Auctionitem")}
                  className={`nav-link ${activeTab == "Auctionitem" ? "active" : ""
                    }`}
                >
                  Buy & Sell with Auction (BSA) items (
                  {postcounts?.ots?.auction || 0})
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={() => handleTabClick("MergersAcquisitions")}
                  className={`nav-link ${activeTab == "MergersAcquisitions" ? "active" : ""
                    }`}
                >
                  <TranslatedText i18nKey="MAS1" /> (
                  {postcounts?.ots?.mergers || 0})
                </a>
              </li>
            </ul>
          </div>
          <div className="tab-content">
            {activeTab == "Packageservice" && (
              <div className="tab-pane active" id="Packageservice">
                <PackagedService autoOpen={urlstate.myotsAutoOpen && activeTab === "Packageservice"} />
              </div>
            )}
            {activeTab == "ProductforSell" && (
              <div className="tab-pane active" id="ProductforSell">
                <ProductsforSell autoOpen={urlstate.myotsAutoOpen && activeTab === "ProductforSell"} />
              </div>
            )}
            {activeTab == "RentalProducts" && (
              <div className="tab-pane active" id="RentalProducts">
                <RentalProducts autoOpen={urlstate.myotsAutoOpen && activeTab === "RentalProducts"} />
              </div>
            )}
            {activeTab == "Auctionitem" && (
              <div className="tab-pane active" id="Auctionitem">
                <AuctionItems autoOpen={urlstate.myotsAutoOpen && activeTab === "Auctionitem"} />
              </div>
            )}
            {activeTab == "MergersAcquisitions" && (
              <div className="tab-pane active" id="MergersAcquisitions">
                <MergersAcquisitions autoOpen={urlstate.myotsAutoOpen && activeTab === "MergersAcquisitions"} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
